import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { Button } from '../Button';
import { CircleCheck } from '../Icons';
export const StyledButton = styled(({ ...lmfButtonProps }) => {
    return _jsx(Button, { ...lmfButtonProps });
}) `
  ${({ status, theme }) => {
    const isResolved = status === 'resolved';
    const isPending = status === 'pending';
    if (isResolved) {
        return css `
        background-color: ${theme.color.fill.celebratory.strong};
        border-color: ${theme.color.fill.celebratory.strong};
        color: ${theme.color.stroke.neutral.text.primary.on.strong};
        transition: none;

        &:hover {
          background-color: ${theme.color.fill.celebratory.strong};
          border-color: ${theme.color.fill.celebratory.strong};
          color: ${theme.color.stroke.neutral.text.primary.on.strong};
        }
      `;
    }
    if (isPending) {
        return css `
        transition: none;
      `;
    }
    return null;
}}
`;
export const SubmitContent = styled.span `
  position: relative;
  min-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
export const StyledCircleCheck = styled(CircleCheck) `
  circle {
    fill: ${o => o.theme.color.fill.background};
  }
  path {
    fill: ${o => o.theme.color.fill.celebratory.strong};
  }
`;
export const IconWrapper = styled.span `
  position: absolute;
  left: clamp(-16px, -8px - 3%, -6px);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${props => (props.visible ? 1 : 0)};
  transition: opacity 300ms ease-in-out;
  will-change: opacity;
  z-index: 1;
  pointer-events: none;
`;
export const ButtonTextContainer = styled.div `
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: ${({ visible }) => (visible ? 'translateX(16px)' : 'translateX(0px)')};
  transition: transform 300ms ease-in-out;
  will-change: transform;
`;
export const IdleText = styled.div `
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 300ms ease-in-out;
  width: 100%;
  will-change: opacity;
`;
export const ActiveText = styled.div `
  position: absolute;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 300ms ease-in-out;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  max-width: calc(100% - 16px);
  will-change: opacity;
`;
//# sourceMappingURL=styles.js.map